import Axios from '@/Axios'

class MitemPayorTypeService {
    async getMitemPayorTypes(data = {}) {
        return await Axios.get('wms.wms.api.mitem_payor_type.get_mitem_payor_types', {
            params: data,
        })
    }
    async createMitemPayorType(data) {
        return await Axios.post('wms.wms.api.mitem_payor_type.create_mitem_payor_type', data)
    }
    async deleteMitemPayorType(mitem_payor_type) {
        const transformedPayorType = mitem_payor_type.map(item => ({ name: item }));
        return await Axios.delete('wms.wms.api.mitem_payor_type.delete_mitem_payor_types', { data: {mitem_payor_type:transformedPayorType} })
    }
}
export default new MitemPayorTypeService()
